export default "__VITE_ASSET__BeO3EEgk__"